import { CoinInfo } from '@/types/common';
import { BtcAddressListItem } from '@/types/wallet';

export const btcFilterCurrentWalletInfo = (
  btcAddressList: BtcAddressListItem[],
  currentStakeToken: CoinInfo
) => {
  const { chainCode } = currentStakeToken;
  const btcAddressListItem = btcAddressList.find(
    (item) => item.chainCode === chainCode
  );
  return btcAddressListItem || btcAddressList[0];
};
